import * as React from 'react'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Grid from '@mui/material/Grid'
import Popover from '@mui/material/Popover'
import { useTheme } from '@mui/material/styles'

import config from 'config'

const apps = [
  { name: 'Aetos Browser', icon: `${config.authUrl}/api/services/assets/stream/app/svgs/browser.svg`, path: '/aetos-browser' },
  { name: 'Aetos Cube', icon: `${config.authUrl}/api/services/assets/stream/app/svgs/cube.svg`, path: '/aetos-cube' },
  { name: 'Aetos AI', icon: `${config.authUrl}/api/services/assets/stream/app/svgs/ai.svg`, path: '/aetos-ai' },
  { name: 'Aetos Lab', icon: `${config.authUrl}/api/services/assets/stream/app/svgs/lab.svg`, path: '/aetos-lab' },
  { name: 'Aetos Canvas', icon: `${config.authUrl}/api/services/assets/stream/app/svgs/canvas.svg`, path: '/aetos-canvas' },
  { name: 'Aetos NIC', icon: `${config.authUrl}/api/services/assets/stream/app/svgs/athena.svg`, path: '/' },
  { name: 'Aetos GO', icon: `${config.authUrl}/api/services/assets/stream/app/svgs/go.svg`, path: '/athena' }
]

export default function AppPopover() {
  const theme = useTheme()
  const [anchorEl, setAnchorEl] = React.useState(null)
  const open = Boolean(anchorEl)
  const id = open ? 'app-popover' : undefined
  const [listApps, setListApps] = React.useState([])
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  React.useEffect(() => {
    // Fetch the list of apps from the server
    const fetchApps = async () => {
      try {
        const response = await fetch(`${config.authUrl}/api/services/assets/stream/configs/menu-apps.json`)
        if (response.ok) {
          const data = await response.json()
          setListApps(data.apps || apps) // Fallback to default apps if none are returned
        } else {
          console.error('Failed to fetch apps:', response.statusText)
          setListApps(apps) // Fallback to default apps on error
        }
      } catch (error) {
        console.error('Error fetching apps:', error)
        setListApps(apps) // Fallback to default apps on error
      }
    }

    fetchApps()
  }, [])

  return (
    <Box display="flex" alignItems="center">
      <Button aria-describedby={id} variant="text" onClick={handleClick}>
        <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="0.5" y="0.5" width="33" height="33" stroke="#D8DAE2" />
          <rect x="8" y="8" width="3" height="3" fill="#D9D9D9" />
          <rect x="15.5" y="8" width="3" height="3" fill="#D9D9D9" />
          <rect x="23" y="8" width="3" height="3" fill="#D9D9D9" />
          <rect x="8" y="15.5" width="3" height="3" fill="#D9D9D9" />
          <rect x="15.5" y="15.5" width="3" height="3" fill="#D9D9D9" />
          <rect x="23" y="15.5" width="3" height="3" fill="#D9D9D9" />
          <rect x="8" y="23" width="3" height="3" fill="#D9D9D9" />
          <rect x="15.5" y="23" width="3" height="3" fill="#D9D9D9" />
          <rect x="23" y="23" width="3" height="3" fill="#D9D9D9" />
        </svg>
      </Button>

      <Popover id={id} open={open} anchorEl={anchorEl} onClose={handleClose} anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}>
        <Grid container sx={{ width: 580, p: 2 }} spacing={2}>
          {listApps.map((app) => (
            <Grid item xs={6} key={app.name}>
              <Button
                onClick={() => {
                  if (!app.disabled) window.location.href = app.path
                }}
                variant="outlined"
                sx={{
                  width: '100%',
                  height: 60,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'start',
                  paddingLeft: 4,
                  backgroundColor: theme.palette.background.paper,
                  transition: 'transform 0.2s',
                  '&:hover': { backgroundColor: '#4C632E', transform: 'scale(1.02)' },
                  borderColor: theme.palette.divider
                }}
                disabled={app.disabled}
              >
                <Box component="img" src={`${config.authUrl}${app.svg}`} alt={app.name} sx={{ height: 20 }} />
              </Button>
            </Grid>
          ))}
        </Grid>
      </Popover>
    </Box>
  )
}
